module.exports = __webpack_public_path__ + "img/KSSBConsult.dfdef9db.png";